(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ride-journal-nankun-photo-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nankun-photo-gallery')) {
    customElements.define('nankun-photo-gallery', class extends HTMLElement {
      connectedCallback() {
        this.prepare = () => this.initialize();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.prepare, { once: true });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.prepare);
        this.events?.abort();
        this.events = null;
      }

      initialize() {
        if (!this.isConnected || this.events) return;
        this.slides = Array.from(this.querySelectorAll('[data-slideshow-slide]'));
        if (!this.slides.length) return;
        this.counter = this.querySelector('[data-slideshow-current]');
        this.index = 0;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelector('[data-slideshow-previous]')?.addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-slideshow-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.addEventListener('touchstart', event => {
          this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { ...options, passive: true });
        this.addEventListener('touchend', event => {
          if (!this.touch) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
          this.touch = null;
        }, { ...options, passive: true });
        this.addEventListener('touchcancel', () => { this.touch = null; }, options);
        this.show(0);
      }

      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.index);
          slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
        });
        this.slides[this.index].querySelector('img')?.setAttribute('loading', 'eager');
        if (this.counter) this.counter.textContent = this.index + 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
